<template>
  <div class="dynamicalDevicePage">系统设备</div>
</template>

<script>
export default {

}
</script>

<style>

</style>